// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import { removeAuthToken, removeRefreshToken } from './auth';

const decodeToken = (token) => {
  try {
    const decoded = jwt_decode(token);
    return decoded;
  } catch {
    removeAuthToken();
    removeRefreshToken();
    return undefined;
  }
};

export default decodeToken;
